import { connect } from 'react-redux';
import { makeStateGenerator } from '../../Demo/states';
import {
  loadChargerSnapshot,
  resetChargerTelemetryState,
  setChargerSnapshot,
  setSnapshotLoading,
} from '../../store/actions';
import {
 getChargerId, getChargerSnapshot, getRealTimeUpdateInterval, getSnapshotLoading,
} from '../../store/selectors';
import View from './CurrentlyComponent';

const generator = makeStateGenerator();

const mapStateToProps = (state, { demo }) => ({
  stateChargerId: getChargerId(state),
  snapshot: getChargerSnapshot(state),
  snapshotLoading: getSnapshotLoading(state),
  updateInterval: getRealTimeUpdateInterval(state),
});

const mapDispatchToProps = (dispatch, { chargerId, demo }) => ({
  load: (ok, fail) => {
    if (demo) {
      const snapshot = generator.next().value;

      if (snapshot) {
        dispatch(setChargerSnapshot(snapshot));
        dispatch(setSnapshotLoading(false));
      }
    } else {
      dispatch(loadChargerSnapshot(chargerId, { ok, fail }));
    }
  },
  resetChargerTelemetryState: () => dispatch(resetChargerTelemetryState()),
});

const Currently = connect(mapStateToProps, mapDispatchToProps)(View);

export default Currently;
